module.exports = "/_next/static/images/error-20771c244fd3a1d6731919c93390abe0.svg";